
import { v4 as uuidv4 } from "uuid";

// Chiave in base_app_setting che attiva/disattiva il popup bloccante delle anagrafiche duplicate.
// Gestita parametricamente: record globale (TenantId null) come default + eventuali override per tenant.
export const ANAG_DUPLICATE_POPUP_BLOCCO_KEY = "AnagDuplicateReminder.PopupBlocco";

export const getLocalStorageSelectedAzienda = async () => {
  return localStorage.getItem("selectedAzienda");
};
export const setLocalStorageSelectedAzienda = async (azienda) => {
  localStorage.setItem("selectedAzienda", azienda);
};

export const getTabelleBase = () => {
  return [    
    { id: "base_mezzo_pagamento", name: "Mezzo di pagamento" },   
    { id: "base_origine_fondi", name: "Origine dei fondi" },   
    { id: "base_tipo_documento", name: "Tipologia documento" },    
  ];
};
export const getTabelleBaseExtra = () => {
  return [
    { id: "base_paese", name: "Nazioni" },
    { id: "base_provincia", name: "Province" },
    { id: "base_comune", name: "Comuni" },
  ];
};
export const getTabelle = () => {
  return [
    { id: "fascicolo", name: "Fascicoli" },
    { id: "prestazione", name: "Prestazioni" },
    { id: "rischio", name: "Rischi" },
    { id: "indicatore_anomalia", name: "Indicatori Anomalia" },
    { id: "anagrafica", name: "Anagrafiche" },
    { id: "allegato", name: "Allegati" },
    { id: "azienda", name: "Aziende" },
    { id: "tenant", name: "Tenant" },
    { id: "user", name: "Utenti" },
    { id: "sos", name: "Segnalazioni operazioni sospette" },
    { id: "autovalutazione", name: "Autovalutazioni" },
  ];
};

export const getLocalStorageImportType = async () => {
  return localStorage.getItem("importType");
};
export const setLocalStorageImportType = async (type) => {
  localStorage.setItem("importType", type);
};

export const getLocalStorageSelectedFascicolo = async () => {
  return localStorage.getItem("selectedFascicolo");
};
export const setLocalStorageSelectedFascicolo = async (fascicolo) => {
  localStorage.setItem("selectedFascicolo", fascicolo);
};
export const getLocalStorageSelectedEntity = () => {
  try {
    const item = localStorage.getItem("selectedEntity");
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error("Error getting localStorage:", error);
    return null;
  }
};
export const setLocalStorageSelectedEntity = async (entityType, entityId, options) => {
  const item = { entityType: entityType, entityId: entityId, options: options };
  localStorage.setItem("selectedEntity", JSON.stringify(item));
};
export const removeLocalStorageSelectedEntity = async () => {
  localStorage.removeItem("selectedEntity");
};

export const getLocalStorageSelectedAutovalutazione = async () => {
  return localStorage.getItem("selectedAutovalutazione");
};
export const setLocalStorageSelectedAutovalutazione = async (
  autovalutazione
) => {
  localStorage.setItem("selectedAutovalutazione", autovalutazione);
};

export const getBase64String = (value) => {
  const cryptoJS = require("crypto-js");
  const byteValue = cryptoJS.enc.Utf8.parse(value);
  const base64Value = cryptoJS.enc.Base64.stringify(byteValue);
  return base64Value.toString();
};

export const getUniqueFileName = () => {
  const d = new Date();
  var name =
    uuidv4().replaceAll("-", "") +
    d.getFullYear() +
    d.getMonth() +
    d.getDate() +
    d.getDay() +
    d.getHours() +
    d.getMinutes() +
    d.getSeconds();
  return name;
};
export const getUniqueReportFileName = (reportTypeName) => {
  const d = new Date();
  var name =
    reportTypeName +
    "_" +
    d.getFullYear() +
    d.getMonth() +
    d.getDate() +
    d.getDay() +
    d.getHours() +
    d.getMinutes() +
    d.getSeconds();
  return name;
};
